var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTShirt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.4695 2L15 3.70822V7.23607L12.1034 6.5305V13.5119H3.97082V6.5305L1 7.23607V3.70822L5.60477 2M10.4695 2H5.60477M10.4695 2C10.4324 2.9779 9.95703 4.56233 8.0557 4.56233C6.15438 4.56233 5.67904 2.9779 5.60477 2",
  stroke: "currentcolor",
  strokeWidth: 1.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTShirt);
export default ForwardRef;